module.exports = __webpack_public_path__ + "static/media/37.92e36557.jpeg";